import { Section } from '@/components/layout';
import { GoldLine, OrnamentIcon } from '@/components/ornaments';
import { Reveal } from '@/components/motion';
import { DisplayTitle, Eyebrow } from '@/components/typography';
import { MANIFESTO } from '../hub.content';
import styles from './HubManifesto.module.css';

/**
 * MANIFIESTO del hub — "Qué es la gira".
 *
 * POR QUE EXISTE: el mockup no lo dibuja, pero lo exigen el master prompt §7
 * (bloque 2 de la estructura del hub) y `07_ARQUITECTURA_LANDINGS.md` §5.2. Es
 * la condicion **C2** que el CENTINEL dejo abierta. ADR-006 §3 manda añadirlo
 * "construido con el lenguaje visual del mockup", y eso es lo que hace: ceja en
 * Cinzel espaciada, titular display de dos lineas, filete dorado y tres tiempos
 * con la misma geometria fina que ya usan la Camara y "Que viviras".
 *
 * DONDE VA: justo detras del mantra. El mantra es el lema de campaña
 * ("Mírate. Libérate del sueño. Despierta.") y sin nada detras se quedaba en
 * **una linea de cinco palabras sin encabezado** entre el hero y "La Ruta del
 * Despertar" — que es exactamente lo que el CENTINEL señalo. Ahora el mantra
 * abre el manifiesto en vez de flotar solo.
 *
 * EL COPY NO SE REDACTA AQUI: sale de `MANIFESTO` en `hub.content.ts`, donde
 * cada linea lleva anotado el documento del brief del que viene. Un manifiesto
 * es el sitio mas facil para colar una frase inventada, asi que la trazabilidad
 * va escrita al lado del texto y no en un informe aparte.
 *
 * SIN `<h1>`: la pagina ya tiene el suyo en el hero. Este titular es `h2` con
 * tamaño display — `DisplayTitle` separa nivel semantico de tamaño visual justo
 * para esto.
 */
export function HubManifesto() {
  return (
    <Section background="surface" labelledBy="hub-manifiesto-title" width="default">
      <div className={styles.manifiesto}>
        <Reveal>
          <Eyebrow align="center" ink="gold" withSparkles>
            {MANIFESTO.eyebrow}
          </Eyebrow>
        </Reveal>

        <Reveal delay={0.06}>
          <DisplayTitle id="hub-manifiesto-title" level={2} size="md" align="center">
            {MANIFESTO.titleLines[0]}
            <br />
            {MANIFESTO.titleLines[1]}
          </DisplayTitle>
        </Reveal>

        <Reveal delay={0.12}>
          <GoldLine ornament="diamond" width="sm" />
        </Reveal>

        <ul className={styles.beats} role="list">
          {MANIFESTO.beats.map((beat, index) => (
            <Reveal as="li" className={styles.beat} delay={0.18 + index * 0.06} key={beat.id}>
              <span className={styles.beatIcon} aria-hidden="true">
                <OrnamentIcon name={beat.icon} size={40} />
              </span>
              <h3 className={styles.beatTitle}>{beat.title}</h3>
              <p className={styles.beatText}>{beat.text}</p>
            </Reveal>
          ))}
        </ul>

        <Reveal delay={0.36}>
          <p className={styles.closing}>{MANIFESTO.closing}</p>
        </Reveal>
      </div>
    </Section>
  );
}
